import React from "react";
import DefaultSpinner from "../../components/DefaultSpinner";
import 'bootstrap/dist/css/bootstrap.css';
import {
    getValuesForSearchConfig,
    fetchConfigs,
    processConfigs,
    updateStateAfterFetch,
    handleError,
    handleIndexDefaultSearchButton
} from "../../components/mainFunctions";
import TemplateShowConfigs from "../templateConfigs/TemplateShowConfigs";

const filterConfigsBySupportAccess = (configs, isSupportImpersonation) => {
    if (isSupportImpersonation) {
        return configs;
    }
    return configs.filter(config => config.isVisible === true);
};

class Configs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configs: [],
            config: "",
            spinner: "",
            configNavContent: "",
            configIndexContent: "",
            modalContent: "",
            modalContent2: "",
            configurationPostSave: "",
            optionSelected: "",
            optionSelectedDescription: "",
        }

    }

    componentDidMount() {
        this.getFeConfigs();
        setTimeout(() => {
            this.keyDownHandler = (e) => handleIndexDefaultSearchButton(e, () => this.getFeConfigs(false, true));
            document.addEventListener('keydown', this.keyDownHandler);
        }, 10);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyDownHandler);
    }

    getFeConfigs = (showNewConfigCreated, isSearch) => {

        const stateUpdateIndex = {
            configIndexContent: "",
            spinner: <DefaultSpinner
                instanceType={document.querySelector("#instanceType").value}
                independent={document.querySelector("#independent").value}
            />
        };

        if (!isSearch) {
            stateUpdateIndex.configNavContent = "";
        }

        this.setState(stateUpdateIndex);

        let orgNodeId = "";
        let type = 0;
        let key = "";
        if (isSearch) {
            const result = getValuesForSearchConfig();
            orgNodeId = result.orgNodeId;
            type = result.type;
            key = this.state.optionSelected;
        }

        const isSupportImpersonation = document.querySelector("#isSupportImpersonation")?.value === "true";

        fetchConfigs(orgNodeId, type, key, 'fe', isSupportImpersonation)
            .then(result => {
                const configsToShow = filterConfigsBySupportAccess(result, isSupportImpersonation);

                const { selectOrgType, selectKeyConfig } = processConfigs(configsToShow, this.handleChange, 'VISITS');
                updateStateAfterFetch(isSearch, configsToShow, this.setState.bind(this), selectOrgType, selectKeyConfig, this.prepareToShowConfig, this.getFeConfigs);

                if (showNewConfigCreated && this.state.configurationPostSave) {
                    configsToShow.forEach(conf => {
                        if (conf.key === this.state.configurationPostSave.key) {
                            this.prepareToShowConfig(conf);
                            this.setState({ configurationPostSave: "" });
                        }
                    });
                }

            })
            .catch(error => {
                handleError(error, this.setState.bind(this));
            });

    };

    handleChange = (option) => {
        this.setState({ optionSelected: option.value })
    };

    prepareToShowConfig = (config) => {
        let divIndex = document.querySelectorAll(".divIndex");
        let arrayIndex = Array.from(divIndex);
        let arrayIndexItem = arrayIndex.map((s) => s.style.display = "none");
        let divShow = document.querySelectorAll(".divShow");
        let arrayShow = Array.from(divShow);
        let arrayShowItem = arrayShow.map((s) => s.style.display = "");
        this.setState({ configIndexContent: "", config: config });
        setTimeout(() => {
            this.setState({ configIndexContent: <TemplateShowConfigs config={config} /> });
        }, 10);
    }

    render() {
        return (
            <>
                {this.state.modalContent}
                {this.state.modalContent2}
                {this.state.configNavContent}
                <br />
                <div className='bodyContent' id='bodyContent'>
                    {this.state.spinner}
                    {this.state.configIndexContent}
                </div>
            </>
        )
    }
}

export default Configs;
